export const PASSWORD_REGEX = {
  uppercase: /[A-Z]/,
  lowercase: /[a-z]/,
  digit: /[0-9]/,
  special: /[!@#$%^&*(),.?":{}|<>]/,
};

export interface PasswordConditions {
  length: boolean;
  uppercase: boolean;
  lowercase: boolean;
  digit: boolean;
  special: boolean;
}

export const validatePassword = (_: any, value: string): Promise<void> => {
  if (!value) {
    return Promise.reject(new Error('Please input password!'));
  }
  if (value.length < 8) {
    return Promise.reject(new Error('Password must be at least 8 characters!'));
  }
  if (!PASSWORD_REGEX.uppercase.test(value)) {
    return Promise.reject(
      new Error('Password must contain at least one uppercase letter!')
    );
  }
  if (!PASSWORD_REGEX.lowercase.test(value)) {
    return Promise.reject(
      new Error('Password must contain at least one lowercase letter!')
    );
  }
  if (!PASSWORD_REGEX.digit.test(value)) {
    return Promise.reject(
      new Error('Password must contain at least one digit!')
    );
  }
  if (!PASSWORD_REGEX.special.test(value)) {
    return Promise.reject(
      new Error('Password must contain at least one special character!')
    );
  }
  return Promise.resolve();
};

export const getPasswordConditions = (
  password: string
): PasswordConditions => ({
  length: password.length >= 8,
  uppercase: PASSWORD_REGEX.uppercase.test(password),
  lowercase: PASSWORD_REGEX.lowercase.test(password),
  digit: PASSWORD_REGEX.digit.test(password),
  special: PASSWORD_REGEX.special.test(password),
});

export const PASSWORD_CONDITIONS_TEXT = [
  { key: 'length', label: '8 characters' },
  { key: 'uppercase', label: '1 uppercase letter (A-Z)' },
  { key: 'lowercase', label: '1 lowercase letter (a-z)' },
  { key: 'digit', label: '1 digit (0-9)' },
  { key: 'special', label: '1 special character (!@#$%^&*...)' },
] as const;
